import React, { useRef, useMemo, useCallback } from 'react';
import { useClickOutside } from '@/core/hooks/useClickOutside';
import { useDropdownAutoScroll } from '@/core/hooks/useDropdownAutoScroll';
import { BaseSelect } from '@/core/components/BaseSelect/BaseSelect';
import './SelectTime.scss';

const BdsIcon = 'bds-icon' as any;

export interface TimeInputProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const SelectTime: React.FC<TimeInputProps> = ({
  value,
  onChange,
  options,
  isOpen,
  onOpen,
  onClose,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleClose = useCallback(() => onClose(), [onClose]);

  useClickOutside(containerRef, handleClose, isOpen);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') onClose();
  };

  const timeOptions = useMemo(() => options.map(o => ({ label: o, value: o })), [options]);

  useDropdownAutoScroll(isOpen, dropdownRef);

  return (
    <div ref={containerRef} className={`time-input-ctrl ${isOpen ? 'time-input-ctrl--open' : ''}`}>
      <button
        type="button"
        className="time-input-ctrl__trigger"
        onClick={() => (isOpen ? onClose() : onOpen())}
        onKeyDown={handleKeyDown}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <input
          type="text"
          value={isOpen ? '' : value}
          placeholder={isOpen ? '|' : ''}
          readOnly
          tabIndex={-1}
        />
        <span className="time-input-ctrl__icon">
          <BdsIcon name="arrow-down" size="small" />
        </span>
      </button>

      {isOpen && (
        <div className="time-input-ctrl__dropdown" ref={dropdownRef}>
          <BaseSelect
            options={timeOptions}
            value={value}
            onChange={(val) => {
              onChange(val);
              onClose();
            }}
            className="time-select"
            alwaysOpen
          />
        </div>
      )}
    </div>
  );
};